import { render, staticRenderFns } from "./GalleryGreyDot.vue?vue&type=template&id=29b4e2ef&"
import script from "./GalleryGreyDot.vue?vue&type=script&lang=js&"
export * from "./GalleryGreyDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports